export const RESPONSIVE_HEIGHT = 700